<template>
    <v-card flat>
        <v-card-text>
            <v-card-title primary-title>
                <div>
                    <h3 class="headline mb-0">Información de Trabajo</h3>
                </div>
            </v-card-title>
            <v-form v-model="valid" v-if="!cargandoDatos">
                <v-container fluid grid-list-md>
                    <v-layout row wrap>
                        <v-flex xs12 md8>
                            <v-text-field
                                    v-model="datosTrabajo.nombre"
                                    label="Nombre de la empresa"
                                    required
                                    autocomplete="nope"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-text-field
                                    v-model="datosTrabajo.telefono"
                                    label="Teléfono"
                                    :mask="'phone'"
                                    autocomplete="nope"
                                    required
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md12>
                            <v-text-field
                                    label="Domicilio (Calle y Número)"
                                    v-model="datosTrabajo.domicilio"
                                    autocomplete="nope"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md12>
                            <v-text-field
                                    label="Colonia"
                                    v-model="datosTrabajo.colonia"
                                    autocomplete="nope"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                            <v-text-field
                                    v-model="datosTrabajo.ciudad"
                                    label="Ciudad"
                                    autocomplete="nope"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                            <v-autocomplete
                                    v-model="datosTrabajo.estado"
                                    :items="estados"
                                    item-value="id"
                                    item-text="nombre"
                                    label="Estado"
                            ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 md12>
                            <v-text-field
                                    v-model="datosTrabajo.puesto"
                                    label="Puesto que ocupa"
                                    autocomplete="nope"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md12>
                            <v-text-field
                                    v-model="datosTrabajo.ant"
                                    label="Antigüedad"
                                    autocomplete="nope"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md12>
                            <v-text-field
                                    v-model="datosTrabajo.nombreJefe"
                                    label="Nombre del Jefe Inmediato Supervisor"
                                    autocomplete="nope"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md12>
                            <v-autocomplete
                                    v-model="datosTrabajo.turno"
                                    :items="turnos"
                                    item-value="id"
                                    item-text="descripcion"
                                    label="Turno"
                            ></v-autocomplete>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
            <v-progress-linear :indeterminate="true" v-else="cargandoDatos"></v-progress-linear>
        </v-card-text>
        <v-divider class="mt-5"></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                    color="primary"
                    flat
                    @click="guardar"
                    :loading="guardarLoading"
                    :disabled="guardarLoading || !valid"
            >Guardar</v-btn>
        </v-card-actions>
        <v-snackbar
                :color="'success'"
                :top="'top'"
                :right="true"
                v-model="snackbar"
        >
            {{ snackbarMensaje }}
            <v-btn flat @click.native="snackbar = false">Cerrar</v-btn>
        </v-snackbar>
    </v-card>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'DatosTrabajo',
    created () {
      this.loadCatalogos()
      this.loadDatosTrabajo()
    },
    data: () => ({
      valid: false,
      cargandoDatos: false,
      guardarLoading: false,
      snackbar: false,
      snackbarMensaje: '',
      estados: [],
      turnos: [
        {id: 1, descripcion: 'Matutino'},
        {id: 2, descripcion: 'Vespertino'},
        {id: 3, descripcion: 'Mixto'}
      ],
      datosTrabajo: {}
    }),
    methods: {
      loadCatalogos () {
        axios.get('catalogo/estados')
          .then(resp => {
            this.estados = resp.data.estados
          })
          .catch(err => {
            console.log(err)
          })
      },
      loadDatosTrabajo () {
        this.cargandoDatos = true
        axios.get('alumno/datos-trabajo')
          .then(resp => {
            this.cargandoDatos = false
            this.datosTrabajo = resp.data.datosTrabajo
          })
      },
      guardar () {
        axios.put('alumno/datos-trabajo', this.datosTrabajo)
          .then(resp => {
            this.snackbar = true
            this.snackbarMensaje = 'Los datos se guardaron correctamente'
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/forms/DatosTrabajo.vue